import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";
import { Breadcrumb, Message, Spin, Card, Row, Col, Alert } from 'antd';
import { Category } from "./../../../models";
import PageHeaderLayout from '../../../layouts/PageHeaderLayout';
import { Form } from '../../../components';
import styles from './index.less';

const mapStateToProps = state => ({
  currentCategory: state.category.current,
  categories: state.global.categories,
});

class CategoryForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  componentDidMount() {
    this.setLoadingFalse();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.match.params.id && !nextProps.match.params.id) {
      this.props.formReset();
      this.setState({ loading: true }, () => this.setLoadingFalse());
    }
  }

  setLoadingFalse = () => {
    setTimeout(() => {
      this.setState({ loading: false });
    }, 300);
  }

  handleSubmit = async (data) => {
    if (data.formData.relation_id) {
      const array = data.formData.relation_id.split(' / ');
      data.formData.relation_id = array[array.length - 1];
    }

    // if (data.formData.image) {
    //   let tempImages = data.formData.image;
    //   if (tempImages.length) {
    //     data.formData.image = tempImages.map((img) => {
    //       if (img.response) {
    //         return {
    //           ...img.response.data,
    //           is_main: img.is_main || false,
    //         };
    //       }

    //       return img;
    //       // ({
    //       //   dump_link: image.response && image.response.data.dump_link,
    //       //   link: image.thumbUrl,
    //       //   is_main: image.is_main || false,
    //       // })
    //     });
    //   }
    // }

    if (this.props.match.params.id) {
      await this.props.categoryUpdate({ body: data.formData });
      console.log('categoryUpdate works: ', this.props);
      Message.success('Амжилттай хүлээн авлаа.');
      if (!this.props.currentCategory.error) this.props.history.push({ pathname: '/categories' });
    } else {
      await this.props.categoryCreate({ body: data.formData });
      console.log('categoryCreate works: ', this.props);
      Message.success('Амжилттай хүлээн авлаа.');
      if (!this.props.currentCategory.error) this.props.history.push({ pathname: '/categories' });
    }
  }

  loading = () => (
    <div className={styles.loading}>
      <Spin />
    </div>
  )

  breadcrumb = (
    <div className={styles.pageTop}>
      <Breadcrumb className={styles.Topbread}>
        <Breadcrumb.Item><Link to="/">Нүүр</Link></Breadcrumb.Item>
        <Breadcrumb.Item><Link to="/categories">Категори</Link></Breadcrumb.Item>
        <Breadcrumb.Item>Категори засварлах</Breadcrumb.Item>
      </Breadcrumb>
    </div>
  );

  form = {
    schema: {
      title: 'Form',
      type: 'object',
      required: ['relation_id', 'alias'],
      column: 12,
      properties: {
        relation_id: {
          type: 'string',
          label: 'Категори',
          options: this.props.categories,
        },
        alias: {
          type: 'string',
          placeholder: 'Категори нэр оруулна',
          label: 'Категори нэр',
        },
        alias_checker: {
          type: 'string',
          placeholder: 'Excel-ээс татах категори нэр',
          label: 'Excel-ээс татах категори нэр',
        },
        image: {
          type: 'string',
          label: 'Зураг',
        },
        active: {
          type: 'boolean',
          label: 'Идэвхтэй эсэх',
        },
      },
    },
    uiSchema: {
      relation_id: {
        "ui:widget": "cascader",
      },
      alias: {
        "ui:widget": "input",
        "ui:placeholder": "Категори нэр оруулна",
      },
      alias_checker: {
        "ui:widget": "input",
        "ui:placeholder": "Excel-ээс татах категори нэр оруулна",
      },
      image: {
        "ui:field": "image",
      },
      active: {
        "ui:widget": "switch-active",
      },
    },
  };

  render() {
    return (
      <PageHeaderLayout content={this.breadcrumb}>
        {
          this.state.loading ?
            this.loading() :
            <Card bordered={false} >
              <Row>
                <Col span={24} className={styles.formCol}>
                  {this.props.currentCategory.error ?
                    <Alert
                      message="Алдаа"
                      description="Категори засах үед алдаа гарлаа."
                      type="error"
                      showIcon
                    /> : null
                  }
                  <Form
                    form={this.form}
                    data={this.props.currentCategory.data}
                    fetchData={this.props.match.params.id ? this.props.categoryDetail : undefined}
                    dataParams={{ body: { id: this.props.match.params.id } }}
                    delete={this.props.categoryDelete}
                    onSubmit={this.handleSubmit}
                  />
                </Col>
              </Row>
            </Card>
        }
      </PageHeaderLayout>
    );
  }
}

CategoryForm.propTypes = {
  categories: PropTypes.array.isRequired,
  match: PropTypes.object.isRequired,
  categoryDetail: PropTypes.func.isRequired,
  categoryDelete: PropTypes.func,
  categoryCreate: PropTypes.func.isRequired,
  categoryUpdate: PropTypes.func.isRequired,
  formReset: PropTypes.func.isRequired,
  currentCategory: PropTypes.object,
  history: PropTypes.object,
};

CategoryForm.defaultProps = {
  currentCategory: undefined,
  categoryDelete: undefined,
  history: undefined,
};


export default connect(mapStateToProps, {
  formReset: Category.reset,
  categoryDetail: Category.get,
  categoryCreate: Category.create,
  categoryDelete: Category.delete,
  categoryUpdate: Category.update,
})(CategoryForm);



// WEBPACK FOOTER //
// ./src/containers/Categories/Form/index.js